import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/cloudproud.webp';
import screenshot_target from '../../../images/letterfunnel/jeroenrinzema.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Jeroen Rinzema"
      firstname="Jeroen"
      companyname="CloudProud"
      competition="Teladoc Health en Luscii"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jeroenrinzema.js